import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingCart, MapPin, LogOut, Home } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useEffect } from "react";

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && (!user || user.role !== "admin")) navigate("/login?next=/admin");
  }, [user, loading, navigate]);

  if (loading || !user) return <div className="p-10 text-center text-[#6C665F]">Loading…</div>;

  const link = ({ isActive }) => (isActive ? "active" : "");

  return (
    <div className="admin-shell flex">
      <aside className="admin-sidebar w-60 min-h-screen p-5 flex flex-col">
        <div className="font-display text-2xl">Eko Admin</div>
        <div className="text-xs opacity-60 mt-1">Cakes & Bakes</div>
        <nav className="mt-8 flex-1 space-y-1">
          <NavLink to="/admin" end className={link} data-testid="admin-nav-dashboard"><LayoutDashboard className="w-4 h-4" /> Dashboard</NavLink>
          <NavLink to="/admin/products" className={link} data-testid="admin-nav-products"><Package className="w-4 h-4" /> Products</NavLink>
          <NavLink to="/admin/orders" className={link} data-testid="admin-nav-orders"><ShoppingCart className="w-4 h-4" /> Orders</NavLink>
          <NavLink to="/admin/pincodes" className={link} data-testid="admin-nav-pincodes"><MapPin className="w-4 h-4" /> Pincodes</NavLink>
        </nav>
        <div className="space-y-1">
          <NavLink to="/" className={link}><Home className="w-4 h-4" /> View Site</NavLink>
          <button data-testid="admin-logout" onClick={() => { logout(); navigate("/"); }} className="w-full text-left"><span className="flex items-center gap-2 px-3 py-2 opacity-75 hover:opacity-100"><LogOut className="w-4 h-4" /> Sign out</span></button>
        </div>
      </aside>
      <main className="flex-1 p-8"><Outlet /></main>
    </div>
  );
}
